export default __webpack_public_path__ + "static/media/Dia-internacional-de-luta-das-mulheres-8M.94de5708.jpg";